export const listEnvironment = [
  { textEnvironment: "Pruebas", valueEnvironment: "T" },
  { textEnvironment: "Desarrollo", valueEnvironment: "D" },
  { textEnvironment: "Producción", valueEnvironment: "P" }
];
